import { render, staticRenderFns } from "./setrole.vue?vue&type=template&id=ec9756a4"
import script from "./setrole.vue?vue&type=script&lang=js"
export * from "./setrole.vue?vue&type=script&lang=js"
import style0 from "./setrole.vue?vue&type=style&index=0&id=ec9756a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports